import { Injectable } from '@angular/core';
import { DistributorListDto } from '@common/generated-api/models/distributor-list-dto';
import { ProducerDto } from '@common/generated-api/models/producer-dto';
import { ResponseProducerDto } from '@common/generated-api/models/response-producer-dto';
import { AdminDistributorsApiService } from '@common/generated-api/services/admin-distributors-api.service';
import { AdminProducersApiService } from '@common/generated-api/services/admin-producers-api.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProducerService {
  producer = new BehaviorSubject<ProducerDto>(null);

  constructor(private adminProducersApiService: AdminProducersApiService) {}

  public loadProducer(): void {
    this.adminProducersApiService.getProducer().subscribe({
      next: (data: ResponseProducerDto) => {
        this.producer.next(data.result);
      },
    });
  }
}
